import React from "react";
import Styles from "../styles/Styles";

function HomePage() {
  return <Styles.Container></Styles.Container>;
}

export default HomePage;
